module.exports = __webpack_public_path__ + "static/media/thermocycler-open.55028346.svg";